module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10252.c9ddc36e.jpg";